import { FacebookFilled, InstagramFilled, LinkedinFilled, TikTokFilled, YoutubeFilled } from "@ant-design/icons"
import { Input } from "antd"
import { SocialLinksData } from "~/types/types"
import { t } from "../../../languages/i18n"

interface SocialLinkProps {
  socialLinks: SocialLinksData
  setSocialLinks: React.Dispatch<React.SetStateAction<SocialLinksData>>
}

const SocialLink = ({ socialLinks, setSocialLinks }: SocialLinkProps) => {
  const handleChange = (platform: string, value: string) => {
    setSocialLinks(prev => ({
      ...prev,
      [platform]: value,
    }))
  }
  return (
    <div className="w-full flex flex-row gap-4 border-b pb-8">
      <div className="w-2/5 flex flex-col gap-2 py-4">
        <h2 className="text-base font-semibold">{t("Social Links")}</h2>
        <p>{t("Add social links")}</p>
      </div>
      <div className=" w-3/5 flex flex-col gap-2 bg-white drop-shadow-md p-4 rounded-lg">
        <div className="w-full flex flex-col gap-2">
          <div className="flex flex-row gap-2">
            <FacebookFilled style={{ fontSize: 18 }} />
            <h2>{t("Facebook Link")}</h2>
          </div>
          <Input
            onChange={e => handleChange("facebook", e.target.value)}
            size="large"
            placeholder="https://www.facebook.com/..."
            value={socialLinks.facebook}
          />
        </div>
        <div className="w-full flex flex-col gap-2 mt-2">
          <div className="flex flex-row gap-2">
            <InstagramFilled style={{ fontSize: 18 }} />
            <h2>{t("Instagram Link")}</h2>
          </div>
          <Input
            onChange={e => handleChange("instagram", e.target.value)}
            size="large"
            placeholder="https://www.instagram.com/..."
            value={socialLinks.instagram}
          />
        </div>
        <div className="w-full flex flex-col gap-2 mt-2">
          <div className="flex flex-row gap-2">
            <LinkedinFilled style={{ fontSize: 18 }} />
            <h2>{t("Linked In Link")}</h2>
          </div>
          <Input
            onChange={e => handleChange("linkedin", e.target.value)}
            size="large"
            placeholder="https://www.linkedin.com/..."
            value={socialLinks.linkedin}
          />
        </div>
        <div className="w-full flex flex-col gap-2 mt-2">
          <div className="flex flex-row gap-2">
            <YoutubeFilled style={{ fontSize: 18 }} />
            <h2>{t("Youtube Link")}</h2>
          </div>
          <Input
            onChange={e => handleChange("youtube", e.target.value)}
            size="large"
            placeholder="https://www.youtube.com/..."
            value={socialLinks.youtube}
          />
        </div>
        <div className="w-full flex flex-col gap-2 mt-2">
          <div className="flex flex-row gap-2">
            <TikTokFilled style={{ fontSize: 18 }} />
            <h2>{t("Tiktok Link")}</h2>
          </div>
          <Input
            onChange={e => handleChange("tiktok", e.target.value)}
            size="large"
            placeholder="https://www.tiktok.com/..."
            value={socialLinks.tiktok}
          />
        </div>
      </div>
    </div>
  )
}

export default SocialLink
